import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const ASSIGN_DESK_OR_BED =
  FORM_FIELDS.INVENTORY.EMPLOYEE.ASSIGN_DESK_OR_BED;

const {
  OFFICE,
  BUILDING,
  ROOM_TYPE,
  ROOM,
  DESK_NUMBER,

  LIVES_ON_PREMISES,

  LIVES_ON_PREMISES_OFFICE,
  LIVES_ON_PREMISES_BUILDING,
  LIVES_ON_PREMISES_ROOM,
  LIVES_ON_PREMISES_BARRACK_NUMBER,
  LIVES_ON_PREMISES_BED_NUMBER,
} = ASSIGN_DESK_OR_BED;

export const employeeAssignDeskOrBedValidation = yup.object().shape({
  [OFFICE]: yup.string().required("Office is required"),
  [BUILDING]: yup.string().required("Building is required"),
  [ROOM]: yup.string().required("Room is required"),
  [ROOM_TYPE]: yup.string().required("Room Type is required"),
  [DESK_NUMBER]: yup.string().required("Desk is required"),

  [LIVES_ON_PREMISES]: yup.boolean(),

  [LIVES_ON_PREMISES_OFFICE]: yup.string().when("lives", {
    is: true,
    then: (schema) => schema.required("Office is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  [LIVES_ON_PREMISES_BUILDING]: yup.string().when("lives", {
    is: true,
    then: (schema) => schema.required("Building is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  [LIVES_ON_PREMISES_ROOM]: yup.string().when("lives", {
    is: true,
    then: (schema) => schema.required("Room is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  [LIVES_ON_PREMISES_BED_NUMBER]: yup.string().when("lives", {
    is: true,
    then: (schema) => schema.required("Bed is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // [LIVES_ON_PREMISES_BARRACK_NUMBER]: yup.string().when("lives", {
  //   is: true,
  //   then: (schema) => schema.required("Barrack is required"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
});

export type EmployeeAssignDeskOrBedFormDataType = yup.InferType<
  typeof employeeAssignDeskOrBedValidation
>;
